module.exports = __webpack_public_path__ + "img/intro_sub_uk.74fd3085.svg";